import { Handle, Position } from "reactflow";

export const getHandles = (nodeId, numberOfHandles) => {
  return [...Array(numberOfHandles)].map((_, index) => (
    <Handle
      key={index}
      type="source"
      id={`${nodeId}-${index}`}
      position={Position.Bottom}
      isConnectable={false}
      className="customSourceHandle"
    />
  ));
};
